import React, { FC } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Clock2Icon } from 'lucide-react';

export const TransactionsDateColumnUnapproved: FC = () => {
  const { t } = useTranslation();

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{t('Waiting for approval')}</Tooltip>}>
      <Clock2Icon size={14} style={{ opacity: 0.4 }} />
    </OverlayTrigger>
  );
};
